import React from 'react'
import { Card } from 'antd'
import { useTranslation } from 'react-i18next'
import InvestmentSummary from './InvestmentSummary'
import { InvestmentsPageBalanceSheetRow } from '../../../redux/pages/investments/types'
import InvestmentGrid from './InvestmentGrid'

type InvestmentGroupProps = InvestmentsPageBalanceSheetRow

const InvestmentGroup: React.FC<InvestmentGroupProps> = ({ balanceSheetRowId, investments, summary, isExisting }) => {
  const { t } = useTranslation()

  if (!investments?.length) return null

  return (
    <Card>
      <Card.Meta
        title={<span style={{ fontSize: 16 }}>{t(`balanceSheet:${balanceSheetRowId}`)}</span>}
        description={<InvestmentSummary summary={summary} />}
      />
      <InvestmentGrid investments={investments} isExisting={isExisting || false} />
    </Card>
  )
}

export default InvestmentGroup
